<script setup lang="ts">
import {
  DgrIcon,
  DgrSnackbar,
  DgrSnackbarContainer,
  useSnackbarAPI,
} from '@stockmarkteam/donguri-ui';
import { defineSnackbarCreator, SnackbarType } from './use-snackbar';

defineSnackbarCreator();
const AnewsSnackbarContainer = DgrSnackbarContainer<SnackbarType>;
const { dismiss } = useSnackbarAPI<SnackbarType>();

// やり直しは一度きりの操作なので、二度押しされないようクリックした時点でスナックバーを消す。
const onClickRetry = (
  id: string | undefined,
  onClickLink: SnackbarType['retry']['onClickLink'],
) => {
  // dismiss は id を省略すると全件を消すため、id が無いときは呼ばない。
  if (id !== undefined) dismiss(id);
  return onClickLink();
};
</script>
<template>
  <AnewsSnackbarContainer>
    <template #link="{ toast }">
      <DgrSnackbar :toast="toast" v-slot="{ message, params }">
        <div class="link-container">
          <RouterLink
            :to="params.link"
            target="_blank"
            rel="noreferrer noopener"
            class="link"
          >
            {{ message }}
          </RouterLink>
          {{ params.suffixText }}
          <DgrIcon name="external-link" :keep-fill="false" class="icon" />
        </div>
      </DgrSnackbar>
    </template>
    <template #action="{ toast }">
      <DgrSnackbar :toast="toast" v-slot="{ params }">
        <div class="action-container">
          <button class="action" @click="params.onClickLink">
            {{ params.linkText }}
          </button>
          {{ params.suffixText }}
        </div>
      </DgrSnackbar>
    </template>
    <!-- DgrSnackbar は toast.type から見た目を決めるため、retry をエラーの見た目で出すには type を差し替える -->
    <template #retry="{ toast }">
      <DgrSnackbar
        :toast="{ ...toast, type: 'error' }"
        v-slot="{ message, params }"
      >
        <div class="retry-container">
          <span>{{ message }}</span>
          <button
            class="action"
            @click="onClickRetry(toast.id, params.onClickLink)"
          >
            {{ params.linkText }}
          </button>
        </div>
      </DgrSnackbar>
    </template>
    <template #progress="{ toast }">
      <DgrSnackbar :toast="toast" v-slot="{ message, params }">
        <div class="progress-container">
          <span class="c-text-regular--m">{{ message }}</span>
          <span class="c-title-bold--m count"
            >{{ params.current }}/{{ params.total }}</span
          >
        </div>
      </DgrSnackbar>
    </template>
  </AnewsSnackbarContainer>
</template>
<style lang="scss" scoped>
.link-container {
  display: flex;
  align-items: center;
  .link {
    color: white;
    text-decoration: underline;
  }
  .icon {
    color: white;
    margin-left: 4px;
  }
}

.action-container,
.retry-container {
  display: flex;
  align-items: center;
  .action {
    appearance: none;
    height: auto;
    color: white;
    text-decoration: underline;
    background: none;
    border: none;
    border-radius: 0;
    padding: 0;
    font: inherit;
  }
}

.retry-container {
  gap: 8px;
}

.progress-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  .count {
    color: $color-green200;
    margin-right: 8px;
  }
}
</style>
